module.exports = __webpack_public_path__ + "img/logo@2x.d599b319.png";